//Retrival.js
import React from 'react'
import { Container, Typography } from '@mui/material';
import ImageRetrieval from '../components/imageRetrieval';
import { Link } from 'react-router-dom';
const Retrival = () => {
    return (
        <div>
            <Typography variant="h4" align="center" gutterBottom>
                Image Retrival    
            </Typography>
            <ImageRetrieval />
            <Link  to="/">Back</Link>
        </div>
    )
}

export default Retrival